// External Imports

// Internal Imports
import { arrayToCsv } from "../../util/arrayToCsv";
import { isISODate, isoDateToString } from "../../util/format-date";
import { TbFileTypeCsv } from "react-icons/tb";

/** ========================================================================
 * * ExportCsvButton Component
 * This component renders a button that allows download a csv file.
 * ========================================================================== */

export default function ExportCsvButton({ array, filename, classes, mapping }) {


  /* ====================== DOWNLOAD HANDLER ====================== */
  const downloadHandler = () => {
    // Check if the array is empty or undefined
    if (!array || array.length === 0) return;

    // Loop through the array and format the objects
    const formattedArray = [];
    array.forEach((object) => {
      const formattedObject = {};

      // Loop through the object and format the values
      Object.keys(object).forEach((key) => {
        if (object[key] == null) formattedObject[key] = "";

        // Format Arrays
        else if (Array.isArray(object[key]))
          formattedObject[key] = object[key].join(", ");

        // Format Booleans
        else if (typeof object[key] === "boolean")
          formattedObject[key] = object[key] ? "True" : "False";

        // Format Dates
        else if (isISODate(object[key])) {
          // Separate date and time
          if (key.toLowerCase().includes("date")) {
            const name = key.toLowerCase().replace("date", "");
            formattedObject[`${name}Date`] = isoDateToString(object[key]);
            formattedObject[`${name}Time`] = isoDateToString(
              object[key],
              "hh:mm a"
            );
          } else formattedObject[key] = isoDateToString(object[key]);
        }

        // Ignore other objects
        else if (typeof object[key] === "object") return;

        // Rest of the values
        else formattedObject[key] = `${object[key]}`;

        if (mapping) {
          formattedObject[mapping.column] = mapping.map(formattedObject[mapping.key]);
        };
      });

      // Push the formatted object to the formatted array
      formattedArray.push(formattedObject);
    });

    arrayToCsv(formattedArray, filename || "export.csv");
  };

  return <TbFileTypeCsv className={classes || "icon"} onClick={downloadHandler} title="Export to CSV"/>;
}
